import { HeartHandshake, Sparkles, Stars, Moon, Crown } from "lucide-react";

export const affiliateProducts = [
  {
    title: "Forever Lovers",
    description: "Find out who your soulmate & twin flame are in a simple test",
    icon: HeartHandshake,
    link: "https://d9a9a2pnxr63bsejafqgxgwtev.hop.clickbank.net",
  },
  {
    title: "Soulmate Sketch",
    description: "Are you ready to finally meet your true soulmate? Many people are shocked to see what their soulmate actually looks like.",
    icon: Sparkles,
    link: "https://09055zqfrf0wcn5qpmzefojcvu.hop.clickbank.net",
  },
  {
    title: "Mystic Sense",
    description: "Expert psychic readings and daily horoscopes to illuminate your path.",
    icon: Stars,
    link: "https://www.mysticsense.com/5minutesfree/#a_aid=twinflames&a_bid=b7580766",
  },
  {
    title: "Moon Reading",
    description: "Your FREE personalized Moon Reading explores the secret depths of your personality, relationships and true purpose in life.",
    icon: Moon,
    link: "https://a215c-oktr0uao5gq807ppvl54.hop.clickbank.net",
  },
  {
    title: "Make Him Worship You",
    description: "Make him treat you like his personal queen. Are You Ready?",
    icon: Crown,
    link: "https://cd8fd2lq1hvzbw2fdes4ohzzdb.hop.clickbank.net",
  },
  {
    title: "Manifest Your Destiny",
    description: "The #1 Secret For Manifesting Wealth, Happiness, Love & Success...",
    icon: Sparkles,
    link: "https://6373e5oqphw2nv0jofr8wiav6k.hop.clickbank.net",
  }
];

export const getRandomAffiliateProducts = (count: number = 2) => {
  const shuffled = [...affiliateProducts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};